/**
 * Route definition for /redirect
 * Redirects users to the Discord server and then to home page.
 *
 * This route performs an immediate redirect to an external Discord invite URL
 * before falling back to the home page.
 *
 * @module routes/redirect
 * @category Routes
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/redirect')({
  beforeLoad: async () => {
    window.location.href = "https://discord.gg/kuNHkBeRKK"
    throw redirect({ to: '/' })
  },
  component: () => null,
})
